<template>
  <mdb-modal removeBackdrop size="md" :show="modalShow" @close="handleClose">
    <mdb-modal-header class="text-center" color="indigo">
      <mdb-modal-title tag="h4" bold class="w-100 text-white">{{
        $t("edit")
      }}</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="mx-3" color="white">
      <mdb-input
        :label="$t('retailerchain_name')"
        type="text"
        v-model="retailerChainName"
      />
      <mdb-input
        :label="$t('retailerchain_description')"
        type="textarea"
        v-model="retailerChainDescription"
      />
    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn @click="saveEditRetailerChain" color="indigo"
        >{{ $t("save") }}<mdb-icon icon="paper-plane" class="ml-1"
      /></mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalBody,
  mdbInput,
  mdbModalFooter,
  mdbModalTitle,
  mdbIcon,
} from "mdbvue";
export default {
  name: "EditRetailerChain",
  props: {
    modalShow: Boolean,
    addRetailerChainState: Boolean,
    name: String,
    active: Number,
    description: String,
    id: Number,
  },
  components: {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbInput,
    mdbModalFooter,
    mdbModalTitle,
    mdbIcon,
  },
  data() {
    return {
      retailerchainpath: "/1.0/front/retailers/chain",
      retailerChainName: this.name,
      retailerChainDescription: this.description,
    };
  },
  methods: {
    handleClose() {
      console.log("modal hide");
      this.$emit("modal-cancelled");
    },
    saveEditRetailerChain() {
      this.postdata = JSON.stringify({
        name: this.retailerChainName,
        description: this.retailerChainDescription,
        id: this.id,
        active: this.active,
      });
      this.$http
        .post(this.retailerchainpath, this.postdata)
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("adding_retailerchain_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
          this.$emit("modal-ok");
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("adding_retailerchain_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          this.$emit("modal-ok");
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
